// extracted by mini-css-extract-plugin
module.exports = {"root":"_255d0e5e","resendTime":"_10435423"};